import { Outlet } from 'react-router-dom';
import { BottomNav } from '@/components/BottomNav';
import { IncomingTransferWatcher } from '@/features/transfer/IncomingTransferWatcher';

export function RootLayout() {
  return (
    <div className="min-h-dvh bg-brand-darkest text-white flex flex-col">
      <main className="flex-1 pb-20 safe-top">
        <Outlet />
      </main>
      <BottomNav />
      <IncomingTransferWatcher />
    </div>
  );
}
